const faqs = [
  {
    q: '51黑料吃瓜网的内容来源是什么？',
    a: '我们的内容主要来自编辑团队的全网监测与用户投稿。编辑团队7x24小时追踪各大社交平台、娱乐媒体和粉丝社群的最新动态，同时接收吃瓜群众的一手爆料投稿。所有发布内容均经过团队的交叉验证，确保信息准确可靠，拒绝虚假炒作。',
  },
  {
    q: '如何在51黑料投稿爆料？',
    a: '你可以通过本页面的"投稿爆料"入口提交你的猛料。我们支持邮件投稿（tips@51heiliao.com）、微信投稿（搜索"51黑料吃瓜"）以及在线表单提交三种方式。投稿时请尽量详细描述事件经过，并附上相关证据材料。我们会对爆料人信息严格保密。',
  },
  {
    q: '51黑料APP有哪些特色功能？',
    a: '51黑料APP相比网页版拥有更流畅的吃瓜体验。核心功能包括：实时推送通知（第一时间接收今日黑料）、离线缓存阅读（没网也能吃瓜）、夜间模式（深夜吃瓜不伤眼）以及个性化话题订阅（只看你感兴趣的瓜）。目前支持iOS和Android双平台。',
  },
  {
    q: '网站上的信息多久更新一次？',
    a: '51黑料采用实时更新机制，编辑团队全天候轮班工作，确保重要爆料第一时间上线。平均每日更新超过200条内容，覆盖明星动态、综艺爆料、影视揭秘、网红圈层等多个维度。遇到重大事件时，我们会启动加急更新流程，保证吃瓜群众不错过任何一个精彩瞬间。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">常见问题</h2>
            <p className="text-sm text-foreground-600 mt-2">你可能想了解的关于51黑料的一切</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="rounded-2xl bg-background-50 border border-background-200/60 p-5 md:p-6"
              >
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-3">
                  {faq.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}